import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool, component_tool } from "@/tool";
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizNotice, WizBrowserExport } = component_tool;
let { checkStrLength, toChinesNum } = utils_tool;
class QuestionType extends WizContainer {
  componentName = 'questionType';

  constructor(props) {
    super(props);
    this.state = {
      type: props['type'],
      parent: props['parent']
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleCategoryFile(nextProps, nextState, key) {
    let o = nextProps[key]
    const {params} = nextState;
    const {type} = params;
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '分类名称',
        field: 'name',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    if (type==='18'){
      columnDefs.push(
        {
          headerName: '封面',
          field: 'imgPreview',
          width: 40,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'middle', horizontal: 'center'},
            font: {
              color: { argb: '0066FF' }
            },
          },
        },
      )
    }
    columnDefs.push(
      {
        headerName: '上级分类',
        field: 'noSelfParentName',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    )
    columnDefs.push({
      headerName: `简介`,
      field: `intro`,
      width: 30,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    })
    if (type === '6' || type === '2' || type === '18') {
      columnDefs.push({
        headerName: `状态`,
        field: `state`,
        width: 30,
        cellStyle: {
          padding: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      })
    }
    if (type === '2' || type==='18') {
      columnDefs.push({
        headerName: `管理权限`,
        field: `targetScope`,
        width: 100,
        cellStyle: {
          padding: "5px 0",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
        },
      })
      columnDefs.push({
        headerName: `使用权限`,
        field: `userTargetScope`,
        width: 100,
        cellStyle: {
          padding: "5px 0",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
        },
      })
    }


    if (o['success']) {
      let dataList = Object.assign([], o['data'])
      if (dataList && dataList instanceof Array) {
        dataList.forEach(data => {
          if (type==='18'){
            if (data.img!=null && data.img!=''){
              data.imgPreview = getOssFilePath(data.img)
              if(data.imgPreview){
                data.imgPreview = data.imgPreview +'?preview=true'
                data.imgPreview = {text : data.imgPreview ,hyperlink:data.imgPreview}
              }
            }
            data['state'] === 0 ? data['state'] = "禁用" : data['state'] === 1 ? data['state'] = "启用" : data['state'] = "未知"
          }else {
            data['state'] === 0 ? data['state'] = "无效" : data['state'] === 1 ? data['state'] = "有效" : data['state'] = "未知"
          }
        })
      }
      WizBrowserExport({
        title: '分类信息',
        sheetName: '分类信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '分类信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
    ]

    if (o['success']) {
      let dataList = Object.assign([], o['data'])
      if (dataList && dataList instanceof Array) {
        let maxCategoryLevel = 0;
        dataList.forEach(data => {
          data['parentName'].split('>').forEach((p, index) => {
            if (index > maxCategoryLevel) {
              maxCategoryLevel = index
            }
            data[`category${index}`] = p
          })
          data['state'] == 0 ? data['state'] = "无效" : data['state'] == 1 ? data['state'] = "有效" : data['state'] = "未知"
        })
        for (let index = 0; index <= maxCategoryLevel; index++) {
          columnDefs.push(
            {
              headerName: `${toChinesNum(index + 1)}级分类`,
              field: `category${index}`,
              width: 30,
              cellStyle: {
                textAlign: 'center',
              },
              style: {
                alignment: { vertical: 'bottom', horizontal: 'left' },
              },
            })

        }
        columnDefs.push({
          headerName: `简介`,
          field: `intro`,
          width: 30,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        })
        if (nextProps['type'] === '2' ||  nextProps['type'] === '18') {
          columnDefs.push({
            headerName: `管理权限`,
            field: `targetScope`,
            width: 100,
            cellStyle: {
              padding: "5px 0",
            },
            style: {
              alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
            },
          })
          columnDefs.push({
            headerName: `使用权限`,
            field: `userTargetScope`,
            width: 100,
            cellStyle: {
              padding: "5px 0",
            },
            style: {
              alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
            },
          })

        }
        if (nextProps['type'] === '6' || nextProps['type'] === '2' || nextProps['type'] === '18') {
          columnDefs.push({
                            headerName: `状态`,
                            field: `state`,
                            width: 30,
                            cellStyle: {
                              padding: "center",
                            },
                            style: {
                              alignment: { vertical: "bottom", horizontal: "left" },
                            },
                          })
        }
      }
      WizBrowserExport({
        title: '分类信息',
        sheetName: '分类信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '分类信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _handleTreeData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 20
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['title'] = checkStrLength(val['title'], len);
          if (val['children'] && val['children'].length > 0) {
            f(val['children'])
          }
        });
      }
      f(o['data'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _render() {
    let { type ,parent} = this.props
    let _reduxTemplateCofig = reduxTemplateCofig({
      type,parent,
      templateConfig: templateConfig({ type,parent, pathname: this.props.location.pathname }),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
        sideBarAdd: this._handleCMD,
        sideBarAddChildren: this._handleCMD,
        sideBarUpdate: this._handleCMD,
        moveUp: this._handleCMD,
        moveDown: this._handleCMD,
        treeData: this._handleTreeData,
        export: this._handleFile,
        exportCategory: this._handleCategoryFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const pathList = ownProps.location.pathname.split('/');
  const categoryType = pathList[pathList.length - 1]
  let typeObj = {
    examination: '0',
    program: '1',
    question: '2',
    // offlineTrain: '3',线下课程与在线课程使用同一个分类
    offlineTrain: '1',
    applicationColumn: '4',
    content:'5',
    label:'6',
    series:'7',
    seriesProgram:'8',
    interactLive:'9',
    credit:'10',
    homework:'11',
    homeworkLabel:'12',
    cert:'13',
    shortVideo: '15',
    verbalTrick: '16',
    learningMaterials: '17',
    proKnowledge:'18',
  }
  let typeParent = {
    applicationColumn : 'no',
    series : 'no',
  }
  const type = typeObj[categoryType]
  const parent = typeParent[categoryType]
  return { type: type,parent:parent }
};

export default connect(mapStateToProps)(QuestionType);
